module.exports = __webpack_public_path__ + "img/ExitusMujer-INF01@2x.59a05584.png";